import { ConnectionIndicator, type ConnectionState } from "../ConnectionIndicator/ConnectionIndicator.tsx";
import { Banner } from "../Notice/Banner.tsx";

/**
 * § Feedback, ConnectionBanner (2026-09-17, by the owner's decision): while the workspace stream is
 * not live, polling or reconnecting, one quiet banner across the top of the whole page says so, drawn
 * as the offline banner is (a hard strip above the rail, the sidebar and the sheet, 2026-09-17, night); when the stream is live there is nothing to show, so nothing is shown. The
 * offline state keeps `OfflineBanner`, with its retry and its queued-write count. A stream the instance
 * refused (`limited`) and one that was closed and is not reconnecting (`stopped`), both 2026-10-14, are
 * drawn amber rather than red: the instance answered, nothing is down, and red would say it is.
 *
 * Drawn through `Banner`, which takes its fade down from Spectrum UI's Animated Alert
 * (`@spectrumui/alert-1`, Apache-2.0) and states what differs from the source, and why.
 */
export function ConnectionBanner({ state }: { readonly state: Exclude<ConnectionState, { readonly kind: "connected" | "offline" }> }) {
  return (
    <Banner variant={state.kind} accent={state.kind === "limited" || state.kind === "stopped" ? "amber" : "red"}>
      <ConnectionIndicator state={state} />
    </Banner>
  );
}
